<template>
  <div class="min-h-screen bg-white text-gray-800 font-sans antialiased">
    <!-- ====== Block 1: Hero Banner ====== -->
    <section
      class="pt-20 pb-16 md:pt-26 md:pb-20 bg-gradient-to-br from-blue-50 via-white to-blue-50 relative overflow-hidden">
      <div
        class="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-100/50 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4">
      </div>
      <div
        class="absolute bottom-0 left-0 w-[400px] h-[400px] bg-blue-50 rounded-full blur-3xl -translate-x-1/4 translate-y-1/3">
      </div>
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div class="grid lg:grid-cols-2 gap-12 items-center">
          <div class="space-y-8">
            <h1 class="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 leading-tight">
              你的<span class="text-blue-600">企业AI</span>工作台
            </h1>
            <p class="text-lg md:text-xl text-gray-500 max-w-lg leading-relaxed">
              具备<strong class="text-gray-700">理解、规划、执行</strong>能力的智能体，从辅助工具到独立生产力，构建企业级通用人工智能基础设施。
            </p>
            <div class="grid gap-3">
              <div v-for="(item, i) in heroSellPoints" :key="i" class="flex items-start gap-3">
                <div class="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg class="w-3.5 h-3.5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span class="text-gray-600">{{ item }}</span>
              </div>
            </div>
            <div class="flex flex-wrap gap-4" style="cursor: pointer;">
              <a @click="toc"
                class="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition text-base"
                style="box-shadow: 0 20px 25px -5px rgba(37,99,235,0.2), 0 8px 10px -6px rgba(37,99,235,0.2)">立即咨询</a>
              <a @click="getmodule('4')"
                class="inline-flex items-center px-6 py-3 border-2 border-gray-200 text-gray-700 rounded-full font-medium hover:border-blue-300 hover:text-blue-600 transition text-base">
                查看应用场景
                <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </a>
            </div>
          </div>
          <div class="hidden lg:block relative">
            <div class="bg-white rounded-2xl shadow-2xl p-4 border border-gray-100">
              <div class="bg-gray-50 rounded-xl p-4 space-y-3">
                <div class="flex items-center gap-2 pb-3 border-b border-gray-200">
                  <div class="flex gap-1.5">
                    <div class="w-3 h-3 rounded-full bg-red-400"></div>
                    <div class="w-3 h-3 rounded-full bg-yellow-400"></div>
                    <div class="w-3 h-3 rounded-full bg-green-400"></div>
                  </div>
                  <span class="text-xs text-gray-400 ml-2 font-mono">WorkBuddy</span>
                </div>
                <div class="space-y-2">
                  <div class="flex gap-2">
                    <div
                      class="w-7 h-7 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs font-bold">
                      AI</div>
                    <div class="bg-blue-50 rounded-xl rounded-tl-sm px-3 py-2 text-sm text-gray-700 max-w-xs">
                      早上好！需要我帮你处理什么？</div>
                  </div>
                  <div class="flex gap-2 justify-end">
                    <div class="bg-gray-100 rounded-xl rounded-tr-sm px-3 py-2 text-sm text-gray-700 max-w-xs">
                      帮我把昨天的会议录音整理成纪要，再生成一份PPT汇报</div>
                  </div>
                  <div class="flex gap-2">
                    <div
                      class="w-7 h-7 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs font-bold">
                      AI</div>
                    <div class="space-y-2 max-w-xs">
                      <div class="bg-blue-50 rounded-xl rounded-tl-sm px-3 py-2 text-sm text-gray-700">收到，开始处理...</div>
                      <div class="bg-blue-50 rounded-xl rounded-tl-sm px-3 py-2 text-sm text-gray-700 space-y-1">
                        <div class="flex items-center gap-2"><svg class="w-4 h-4 text-green-600" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                          </svg>会议纪要已生成</div>
                        <div class="flex items-center gap-2"><svg class="w-4 h-4 text-green-600" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                          </svg>12页商务PPT已生成</div>
                        <div class="flex items-center gap-2 animate-pulse">
                          <div class="w-4 h-4 border-2 border-blue-400 border-t-transparent rounded-full animate-spin">
                          </div>数据看板制作中...
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg px-4 py-3 border border-gray-100">
              <div class="text-2xl font-bold text-blue-600 counter-num">820<span
                  class="text-sm text-gray-400 font-normal">万</span></div>
              <div class="text-xs text-gray-500">桌面智能体月访问增量</div>
              <div class="text-xs text-green-600 mt-1">排名第1</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== Block 2: 产品概述 ====== -->
    <section class="md:py-20 bg-white" style="padding-bottom: 30px;" id="module1">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" id="module1">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">WorkBuddy 是什么</h2>
          <p class="text-lg text-gray-500 max-w-2xl mx-auto">不只是对话助手，是能理解任务、规划路径、并自主执行的AI智能体</p>
        </div>

        <div class="grid md:grid-cols-2 gap-8 mb-16" id="module2">
          <div v-for="(item, i) in productPositions" :key="i"
            class="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-blue-100">
            <div class="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center mb-4" v-html="item.icon">
            </div>
            <h3 class="text-xl font-bold text-gray-900 mb-3">{{ item.title }}</h3>
            <p class="text-gray-600 leading-relaxed" v-html="item.desc"></p>
          </div>
        </div>

        <div class="mb-16" id="module2">
          <h3 class="text-2xl font-bold text-gray-900 text-center mb-10">产品 4 大形态，覆盖全场景</h3>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div v-for="(item, i) in productForms" :key="i"
              class="text-center p-6 rounded-2xl bg-gray-50 hover:bg-blue-50 transition-colors"
              style="cursor: pointer;padding-top: 0px;">
              <div class="flex items-center justify-center mx-auto" style="width: 100px;position: relative;top: -6px;">
                <img :src="item.icon">
              </div>
              <div class="font-bold text-gray-900 text-lg mb-1">{{ item.title }}</div>
              <div class="text-sm text-gray-500">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== Block 3: 核心能力 ====== -->
    <section id="module3" style="position: relative;padding:60px 0px;height: 700px;">
      <img src="../../assets/hometo/wdhx.jpg" style="position: absolute;top: 0px;left: 0px;height: 100%;width: 100%;">
      <div class="mx-auto" style="position: relative;z-index: 1;">
        <div class="text-center mb-16" style="color: #fff;">
          <h2 class="text-3xl md:text-4xl font-bold mb-4">5 大核心能力</h2>
          <p class="text-lg max-w-2xl mx-auto">岗位全覆盖、企业全场景，每个员工拥有自己的 AI 搭档</p>
        </div>
        <div style="" id="scrollcontainer" class="scrollcontainer">
          <div style="display: flex;justify-content:space-between;width: 2000px;user-select: none;">
            <div v-for="(item, i) in capabilities" :key="i"
              class="bg-white rounded-2xl p-6 border border-gray-100 lifors" style="cursor: pointer;width: 380px;">
              <div class="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                :style="{ background: item.iconBg }">
                <span v-html="item.icon" class="w-6 h-6" :style="{ color: item.iconColor }"></span>
              </div>
              <h3 class="text-lg font-bold text-gray-900 mb-2">{{ item.title }}</h3>
              <p class="text-gray-500 text-sm leading-relaxed">{{ item.desc }}</p>
              <div class="mt-3 flex flex-wrap gap-1.5">
                <span v-for="(tag, ti) in item.tags" :key="ti" class="text-xs px-2 py-0.5 rounded-full"
                  :style="{ background: item.tagBg, color: item.iconColor }">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="rounded-2xl p-6 text-white col-span-full lg:col-span-3"
          style="width: 1200px;margin: 0px auto;margin-top: 30px;">
          <div class="grid md:grid-cols-4 gap-6">
            <div v-for="(item, i) in mgmtItems" :key="i" class="text-center">
              <div class="text-3xl font-bold mb-1">{{ item.title }}</div>
              <p class="text-white/80 text-sm">{{ item.desc }}</p>
            </div>
          </div>
          <div class="text-center mt-8 pt-6" style="border-top:1px solid rgb(239 239 239 / 50%);">
            <p class="text-white/90 font-bold text-lg">效率放开 · 风险管住 · 资产留下 · 价值算清</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== Block 4: 十大应用场景 ====== -->
    <div id="module4">
      <section id="scenes" class="py-16 md:py-20 bg-gray-50" style="background: #fff;padding-bottom: 0px;">
        <div class="">
          <div class="text-center mb-16">
            <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">十大热门应用场景</h2>
            <p class="text-lg text-gray-500 max-w-2xl mx-auto">覆盖制造业、IT服务、电商、医疗、金融等核心行业，用数据说话</p>
          </div>
          <div id="scrollcontainerb" class="scrollcontainer">
            <div class="" style="display: flex;justify-content: space-between;width: 4100px;user-select: none;">
              <div v-for="(item, i) in scenes" :key="i"
                class="scene-card bg-white rounded-2xl p-6 border border-gray-100 shadow-sm"
                style="cursor: pointer;width: 390px;">
                <div class="scene-icon w-10 h-10 rounded-xl flex items-center justify-center mb-4"
                  :style="{ background: item.iconBg }">
                  <span class="font-bold text-lg" :style="{ color: item.iconColor }">{{ item.num }}</span>
                </div>
                <h3 class="font-bold text-gray-900 mb-2">{{ item.title }}</h3>
                <p class="text-sm text-gray-500 mb-4 leading-relaxed">{{ item.desc }}</p>
                <div class="flex items-center gap-2 mb-3 flex-wrap">
                  <span v-for="(tag, ti) in item.tags" :key="ti"
                    class="bg-green-50 text-green-700 text-xs font-bold px-2 py-1 rounded">{{ tag }}</span>
                </div>
                <div class="text-xs text-gray-400">案例：{{ item.cases }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- ====== Block 5: 行业应用案例 ====== -->
    <section class="py-16 md:py-20 bg-white" id="module5">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">行业应用案例</h2>
          <p class="text-lg text-gray-500 max-w-2xl mx-auto">制造、IT服务为两大基本盘（合计约37%），电商、医疗、金融等构成第二梯队</p>
        </div>
        <div
          style="margin-top: 50px; display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
          <div class="scene-card" v-for="(x, i) in yinganli" :key="i" @click="toa(i)"
            style="width: 380px;background: #f9fafb;margin-bottom: 30px;border-radius: 10px;cursor: pointer;">
            <div :style="{ backgroundImage: 'url(' + x.bannerImg + ')' }"
              style="margin: 0px auto;height: 51px;background-size:100% 100%;text-align: center;line-height: 51px;font-size: 18px;color: #fff;width: 228px;">
              {{ x.title }}
            </div>
            <div style="padding:15px 30px;border-radius: 10px;font-size: 14px;color: #666666;">
              <div v-for="(z, j) in x.list" :key="j" style="margin-top: 6px;">★ {{ z }}</div>
              <div :style="{ color: x.color }" style="background: #fff;text-align: center;font-weight: bold;
              height: 40px;line-height: 40px;margin-top: 20px;margin-bottom: 6px;border-radius: 25px;">
                {{ x.tagText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ====== Block 6: 岗位价值 ====== -->
    <section class="py-16 md:py-20 bg-gray-50" id="module6">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">对不同岗位的价值</h2>
          <p class="text-lg text-gray-500 max-w-2xl mx-auto">从上到下，从业务到职能，每个角色都有专属的 AI 搭档</p>
        </div>

        <div class="">
          <table class="w-full bg-white rounded-2xl shadow-sm border border-gray-100">
            <thead>
              <tr class="bg-blue-50">
                <th class="text-left py-4 px-6 font-bold text-gray-900">岗位</th>
                <th class="text-left py-4 px-6 font-bold text-gray-900">典型场景</th>
                <th class="text-left py-4 px-6 font-bold text-gray-900">核心痛点</th>
                <th class="text-left py-4 px-6 font-bold text-gray-900">WorkBuddy 价值</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              <tr v-for="(role, ri) in roleTable" :key="ri" class="role-row hover:bg-gray-50 transition-colors">
                <td class="py-4 px-6 font-medium text-gray-900 role-cell">
                  <span class="role-name">{{ role.name }}</span>
                  <div class="role-popup">
                    <div class="role-popup-header">
                      <div>
                        <div class="role-popup-title">{{ role.name }} <span class="role-popup-tag">AI 智能搭档</span></div>
                        <div class="role-popup-subtitle">{{ role.popupSubtitle }}</div>
                      </div>
                      <div class="role-popup-arrow">→</div>
                    </div>
                    <div class="role-scenarios">
                      <div v-for="(sc, si) in role.popupScenes" :key="si" class="role-scenario">
                        <div class="scenario-num">0{{ si + 1 }}</div>
                        <div class="scenario-title">{{ sc.title }}</div>
                        <div class="scenario-desc">{{ sc.desc }}</div>
                        <div class="scenario-value">{{ sc.value }}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="py-4 px-6 text-sm text-gray-600">{{ role.scenes }}</td>
                <td class="py-4 px-6 text-sm text-gray-500">{{ role.pain }}</td>
                <td class="py-4 px-6 text-sm"><span class="text-blue-600 font-medium">{{ role.value }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- ====== Block 7: 产品版本与定价 ====== -->
    <section class="py-16 md:py-20 bg-white" id="module7">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">产品版本与定价</h2>
          <p class="text-lg text-gray-500 max-w-2xl mx-auto">从小范围试点到全员部署，灵活匹配企业需求</p>
        </div>

        <div class="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <div v-for="(item, i) in pricingPlans" :key="i"  @mousemove="setRecommended(i)" style="cursor: pointer;"
            class="rounded-2xl p-8 relative overflow-hidden transition-colors"
            :class="item.recommended ? 'border-2 border-blue-200' : 'border-2 border-gray-200 hover:border-blue-300'"
            :style="item.recommended ? 'background: linear-gradient(to bottom, rgba(239, 246, 255, 0.5), #fff);' : ''">
            <div v-if="item.recommended"
              class="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-4 py-1 rounded-bl-xl">推荐</div>
            <div class="text-lg font-bold text-gray-900 mb-2">{{ item.name }}</div>
            <div style="display: flex;align-items: end;">
              <div class="flex items-baseline gap-1 mb-6">
                <span class="text-4xl font-extrabold text-gray-900">{{ item.price }}</span>
                <span class="text-gray-500">/人/月</span>
              </div>
              <div style="margin-left: 15px;" class="mb-6"><span class="inline-block px-3 py-1 rounded-full text-sm font-medium"
                  :class="item.recommended ? 'bg-blue-100 text-blue-700' : 'bg-blue-50 text-blue-700'">{{ item.tag
                  }}</span>
              </div>
            </div>
            <div style="color:rgba(75, 85, 99, var(--tw-text-opacity));">{{ item.desc }}</div>
            <a style="cursor: pointer;margin-top: 20px;" @click="toc"
              class="block text-center py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition">获取报价</a>
            <div style="margin:20px 0px;color: #1e66d1;font-size: 17px;">企业特性</div>
            <ul class="space-y-3" style="">
              <li v-for="(feature, fi) in item.features" :key="fi" class="flex items-start gap-3 text-gray-600">
                <svg class="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24" style="color: #1e66d1;">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <span v-html="feature"></span>
              </li>
              <li v-for="(feature, fi) in item.featuresNo" :key="fi" class="flex items-start gap-3 text-gray-600">
                <svg v-if="i == 1" class="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24" style="color: #1e66d1;">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <svg v-if="i == 0" style="position: relative;top: 3px;" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12 4L4 12" stroke="#686C91" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4 4L12 12" stroke="#686C91" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                <span v-html="feature"></span>
                <span v-if="i == 1" style="display: inline-block;padding: 1px 8px;border-radius: 999px;font-size: .72em;line-height: 1.5;color: #fff;background: #1e66d1;border: 0;vertical-align: middle;white-space: nowrap;position: relative;top: 2px;">专享</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="text-center mt-10">
          <p class="text-gray-500 text-sm">担心预算？可从 1-2 个高频痛点部门（如财务、运营）做小范围试点，跑出数据后再决定是否全员铺开。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
var isMouseDown = false;
var isMouseDownb = false;
var ul = null;
var ulb = null;
export default {
  name: 'WorkBuddy',
  data() {
    return {
      heroSellPoints: [
        '有 Office 就能用，覆盖全行业通用场景',
        '开箱即用，零门槛上手 — 说句话就能写文档、做PPT、整理纪要',
        '桌面端 + 企微 + 小程序 + 管理后台，四端协同'
      ],
      productPositions: [
        {
          icon: '<svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>',
          title: '产品定位',
          desc: '具备<strong>理解、规划、执行能力</strong>的智能体，能够模拟人类操作习惯，接管繁琐的电脑端重复性工作。突破传统办公软件限制，实现非结构化数据处理与跨系统无缝协同。'
        },
        {
          icon: '<svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/></svg>',
          title: '战略定位',
          desc: '从辅助工具演进为<strong>独立生产力</strong>，构建企业级通用人工智能基础设施。混元3.0 Preview 性价比拉满，登顶海外 Open Router 榜首，成本可控、数据安全。'
        }
      ],
      productForms: [
        { icon: require("../../assets/hometo/z1.png"), title: '桌面端', desc: 'PC/Mac 原生应用，深度操作系统集成' },
        { icon: require("../../assets/hometo/z2.png"), title: '小程序', desc: '微信/企微内轻量使用，随时随地' },
        { icon: require("../../assets/hometo/z3.png"), title: '管理后台', desc: '企业管理员统一管控、数据分析' },
        { icon: require("../../assets/hometo/z4.png"), title: '企微/IM平台', desc: '企微内置 Claw 形态，无缝融入日常工作流' }
      ],
      capabilities: [
        {
          icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>',
          iconBg: '#eff6ff', iconColor: '#2563eb', title: '智能办公', desc: '邮件/会议纪要/公文写作/周报一键生成，文档处理时间减少85%', tags: ['全员通用'], tagBg: '#eff6ff'
        },
        {
          icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/></svg>'
          , iconBg: '#f0fdfa', iconColor: '#0d9488', title: '数据处理', desc: '多文档智能整合、OCR识别、自动填表、财务报表分析，错误率降低90%', tags: ['财务', 'HR', '运营'], tagBg: '#eff6ff'
        },
        {
          icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>'
          , iconBg: '#faf5ff', iconColor: '#9333ea', title: '内容生产', desc: '文案/海报/PPT/短视频脚本批量生成，内容产出快10倍，创作耗时减80%', tags: ['市场', '品牌'], tagBg: '#faf5ff'
        },
        {
          icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/></svg>'
          , iconBg: '#fffbeb', iconColor: '#d97706', title: '管理决策', desc: '数据看板、销售异常预警、战略提案撰写，决策效率提升80%', tags: ['管理层'], tagBg: '#fffbeb'
        },
        {
          icon: '<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/></svg>'
          , iconBg: '#ecfdf5', iconColor: '#059669', title: '产研提效', desc: '竞品分析报告、PRD模板套用、Code Review、测试用例自动构建，研发提效50%+', tags: ['产品', '研发'], tagBg: '#ecfdf5'
        }
      ],
      mgmtItems: [
        { title: '管人', desc: '权限管控 · 组织架构同步 · 审批机制' },
        { title: '管AI', desc: '多模型调度 · 专属知识库 · 统一Prompt' },
        { title: '管钱', desc: '用量追溯 · 明细管理 · 财务审计' },
        { title: '管安全', desc: 'IP白名单 · 日志留存 · API管理' }
      ],
      scenes: [
        { num: '01', iconBg: '#eff6ff', iconColor: '#2563eb', title: '智能办公', desc: '邮件收发、会议纪要、公文写作、跨部门协同，一键搞定重复性文字工作', tags: ['文档处理 -85%', '人效 3-5x'], cases: '某跨国制造企业中国分支、某具身智能机器人公司' },
        { num: '02', iconBg: '#eef2ff', iconColor: '#4f46e5', title: '数据处理', desc: '多文档智能整合、OCR自动填表、多源数据汇总，告别手工复制粘贴', tags: ['错误率 -90%', '半天→几分钟'], cases: '某动物体外检测设备出海企业、某税务咨询公司' },
        { num: '03', iconBg: '#faf5ff', iconColor: '#9333ea', title: '运营提效', desc: '自动化账号运营、报告智能预审与邮件分发、OA单据归纳与自动审批', tags: ['人力成本 -80%'], cases: '某社区电商运营ISV、某五金塑胶制造厂' },
        { num: '04', iconBg: '#fffbeb', iconColor: '#d97706', title: '营销获客', desc: '智能找热点、一键生成抖音/小红书图文脚本，批量产出高质量营销素材', tags: ['发文量 +100%', '耗时 -80%'], cases: '某美妆品牌、某文化传媒电商直播公司' },
        { num: '05', iconBg: '#ecfdf5', iconColor: '#059669', title: '智能客服与销售助手', desc: '企微IM入口 + 知识库，AI驱动全渠道对话引擎，服务与业务智能化', tags: ['回复量 x2', '处理时间 -50%'], cases: '某金融服务平台、某跨境电商品牌' },
        { num: '06', iconBg: '#fff1f2', iconColor: '#e11d48', title: '内容生产（漫剧/图文）', desc: '剧本智能解析 → 自动分镜生成 → 图文视频合成，视觉内容流水线', tags: ['效率 +60%', '成本 -40%'], cases: '某AI漫剧数字传媒公司' },
        { num: '07', iconBg: '#f0fdfa', iconColor: '#0d9488', title: '管理决策提效', desc: '管理层一站式入口，上传文档直接分析，销售异常实时监控与自动预警', tags: ['决策效率 +80%', '事务时间 -70%'], cases: '某金融投资公司、某食品调味品制造企业' },
        { num: '08', iconBg: '#ecfeff', iconColor: '#0891b2', title: '产研提效', desc: '一句话生成竞品报告、PRD模板智能套用、Code Review & 测试用例自动构建', tags: ['PRD 1天→10min', '研发提效50%+'], cases: '某跨境电商研发部门' },
        { num: '09', iconBg: '#eff6ff', iconColor: '#2563eb', title: '知识沉淀', desc: '一键打通腾讯文档/会议/Ima/乐享/企业自建知识平台，智能问答精准溯源', tags: ['上手 数周→分钟'], cases: '某可穿戴智能硬件公司、某卫生纸无纺布智能制造企业' },
        { num: '10', iconBg: '#fff7ed', iconColor: '#ea580c', title: '行业定制', desc: '自建Skill + MCP/API深度融合业务系统，从通用AI到行业专家', tags: ['交付提效30%+', '数月→数周'], cases: '某商业航天公司' }
      ],
      yinganli: [
        {
          "title": "制造业",
          "bannerImg": require("@/assets/hometo/hyal-1@2x.png"),
          "color": "#1e66d1",
          "tagText": "事务性时间省70%·文档查找-70%",
          "list": [
            "合同/报价单自动生成与智能审核",
            "生产报表自动汇总·ERP/SRM/钉钉打通",
            "多基地运营数据分析与一句话生成日报",
            "技术文档智能检素与流程标准化"
          ]
        },
        {
          "title": "电商/跨境电商",
          "bannerImg": require("@/assets/hometo/hyal-2@2x.png"),
          "color": "rgb(234 88 12)",
          "tagText": "数据处理-80%·运营效率+30%",
          "list": [
            "多语种客服与产品详情文案",
            "跨境电商大盘监控，广告投流优化",
            "ERP订单，营销文案，图片批量处理",
            "智能客服，Al运营预测，内容自动化"
          ]
        },
        {
          "title": "医疗医药/生物科技",
          "bannerImg": require("@/assets/hometo/hyal-3@2x.png"),
          "color": "rgb(22 163 74)",
          "tagText": "人力时间-90%·新人上手-50%",
          "list": [
            "GMP合规文档生成与法务合同初审",
            "批生产记录与检验报告自动填充",
            "实验报告AI生成·文献语义检索",
            "专项助手，自定义Skills·用量管理"
          ]
        },
        {
          "title": "金融行业",
          "bannerImg": require("@/assets/hometo/hyal-4@2x.png"),
          "color": "rgb(122 75 202)",
          "tagText": "报表等待-70%·合规南查-50%",
          "list": [
            "资讯抓取与研报自动撰写",
            "报表自动生成·风控指标看板",
            "金融走势分析与选股Skills",
            "资产投资决策提效·风险处置"
          ]
        },
        {
          "title": "建筑装饰/科技服务",
          "bannerImg": require("@/assets/hometo/hyal-5@2x.png"),
          "color": "rgb(138 69 28)",
          "tagText": "合同30min→3min·投标响应+70%",
          "list": [
            "标书与报价单自动生成",
            "项目方案书掇写与数据扒取",
            "营销文案合规审核·条款校验",
            "合同自动生成，客服标准回复"
          ]
        },
        {
          "title": "媒体/广告/营销",
          "bannerImg": require("@/assets/hometo/hyal-6@2x.png"),
          "color": "rgb(198 61 122)",
          "tagText": "内容产能10x·创作耗时-80%",
          "list": [
            "AI漫剧·智能内容生成",
            "小红书运营，营销文案批量产出",
            "直播脚本与招商文案生成",
            "创意内容流水线·活动策划提效"
          ]
        },
        {
          "title": "物流/供应链",
          "bannerImg": require("@/assets/hometo/hyal-7@2x.png"),
          "color": "rgb(14 139 169)",
          "tagText": "人工录入-90%·处理量+10x",
          "list": [
            "企微客服·RAG知识库·多模态处理",
            "报关单OCR识别·票务自动化",
            "运维开发提效·ERP内部系统"
          ]
        },
        {
          "title": "汽车",
          "bannerImg": require("@/assets/hometo/hyal-8@2x.png"),
          "color": "rgb(193 49 49)",
          "tagText": "研发效率+40%·缺陷-50%",
          "list": [
            "智能编程，代码安全，合规交付",
            "报表录入·Figma设计解析·库存盘点",
            "车载系统深度开发，漏洞排查"
          ]
        },
        {
          "title": "教育/培训",
          "bannerImg": require("@/assets/hometo/hyal-9@2x.png"),
          "color": "rgb(192 133 9)",
          "tagText": "检索时间-90%·PPT制作2H→15min",
          "list": [
            "政策资讯智能采集·多源政府网站监控",
            "自动化数据采集·研究分析，领导驾驶舱",
            "合同审核·招标解读，教培方案·Excel提效",
            "PPT制作·文档处理效率大幅提升"
          ]
        }
      ],
      roleTable: [
        {
          name: '产品经理', popupSubtitle: '从需求洞察到产品落地的全流程 AI 助理',
          popupScenes: [
            { title: '竞品分析报告', desc: '自动抓取竞品公开信息，AI 生成结构化对比表与差异化洞察', value: '1 天 → 30 分钟' },
            { title: 'PRD 文档撰写', desc: '基于一句话需求自动生成完整 PRD 框架，含流程图与验收标准', value: '新人也能写专业文档' },
            { title: '用户调研分析', desc: '批量处理问卷/访谈记录，智能提炼核心洞察与待办事项', value: '洞察效率提升 5 倍' }
          ],
          scenes: '需求分析、竞品调研、PRD编写', pain: '信息收集耗时，文档撰写繁琐', value: 'AI快速生成文档，智能提炼竞品信息'
        },
        {
          name: '运营人员', popupSubtitle: '从内容生产到数据复盘的全链路运营助理',
          popupScenes: [
            { title: '营销文案生成', desc: '一键生成多平台适配的图文/短视频脚本，匹配品牌调性', value: '1 小时 → 5 分钟' },
            { title: '活动复盘报告', desc: '自动汇总活动数据，生成可视化复盘报告与改进建议', value: '撰写耗时减少 80%' },
            { title: '用户舆情监控', desc: '实时抓取全网评论，AI 提炼热点话题与负面预警', value: '响应从小时级到分钟级' }
          ],
          scenes: '活动策划、文案撰写、数据复盘', pain: '创意枯竭，多渠道分发耗力', value: '提供海量创意灵感，一键生成数据报告'
        },
        {
          name: '管理层', popupSubtitle: '从数据洞察到经营决策的全方位智能管家',
          popupScenes: [
            { title: '业务数据看板', desc: '整合 ERP/CRM/财务系统数据，生成实时经营看板与趋势分析', value: '1 天 → 实时' },
            { title: '经营报告自动生成', desc: '自动汇总各部门数据，AI 撰写周报/月报/季报及经营分析', value: '文书工作量减少 70%' },
            { title: '风险预警', desc: '监控关键指标异常，自动推送预警到企微并给出建议', value: '从被动响应到主动预警' }
          ],
          scenes: '战略规划、业务审批、团队管理', pain: '缺乏实时数据支撑，信息孤岛', value: '全局数据洞察看板，智能辅助高效决策'
        },
        {
          name: '销售人员', popupSubtitle: '从客户洞察到合同签署的全周期销售助理',
          popupScenes: [
            { title: '客户画像智能分析', desc: '自动整合客户多源信息，生成 360° 客户画像与决策链图谱', value: '30 分钟 → 3 分钟' },
            { title: '定制方案秒级生成', desc: '基于客户痛点自动生成针对性解决方案，含报价与案例匹配', value: '方案制作效率提升 5 倍' },
            { title: '合同智能拟定', desc: '标准条款自动套用，特殊条款智能提示风险点与修改建议', value: '2 小时 → 15 分钟' }
          ],
          scenes: '客户跟进、方案制作、合同拟定', pain: '定制方案耗时，客户背景了解不足', value: '秒级生成专属方案，智能客户画像'
        },
        {
          name: 'HR', popupSubtitle: '从招聘选拔到员工发展的全周期人力助理',
          popupScenes: [
            { title: '简历智能筛选', desc: '自动解析简历并与岗位 JD 匹配打分，输出推荐排序与亮点', value: '3 小时 → 20 分钟' },
            { title: '员工培训课件生成', desc: '基于业务需求自动生成定制化培训内容，含案例与考核题', value: '1 周 → 半天' },
            { title: '员工问答助手', desc: '7×24 解答薪酬、福利、规章等高频问题，支持多端接入', value: '事务性咨询减少 60%' }
          ],
          scenes: '简历筛选、面试安排、员工培训', pain: '海量简历筛选疲劳，培训更新慢', value: 'AI精准匹配简历，自动生成培训课件'
        },
        {
          name: '财务人员', popupSubtitle: '从对账核算到预算管控的智能财务助手',
          popupScenes: [
            { title: '自动对账', desc: '跨银行、跨平台账单自动核对，异常条目智能标红并归类', value: '4 小时 → 15 分钟' },
            { title: '多维财务报表', desc: '一键生成管理报表、税务报表、分析报表，自动图表化', value: '1 天 → 10 分钟' },
            { title: '预算执行分析', desc: '实时对比预算与实际，预测偏差并提示调整建议', value: '颗粒度从天细化到小时' }
          ],
          scenes: '报表制作、费用审核、预算分析', pain: '人工核对易错，报表周期长', value: '自动化数据核对，智能生成多维报表'
        },
        {
          name: '法务人员', popupSubtitle: '从合同审查到合规咨询的全方位风控助手',
          popupScenes: [
            { title: '合同智能审查', desc: '逐条比对合同条款，自动标红风险点与缺失条款，给出修改建议', value: '2 小时 → 10 分钟' },
            { title: '法规实时跟踪', desc: '实时监控行业法规变化，AI 解读影响范围并推送应对建议', value: '从被动应对到主动预警' },
            { title: '法律咨询问答', desc: '内部员工合规咨询秒级响应，附法条引用与历史判例参考', value: '响应效率提升 5 倍' }
          ],
          scenes: '合同审查、合规排查、法务咨询', pain: '条款审查字斟句酌耗时，风险易遗漏', value: 'AI智能审查合同，自动提示合规风险'
        }
      ],
      pricingPlans: [
        {
          name: '企业旗舰版',
          desc: '面向企业和团队，提供丰富的企业特性',
          price: '¥198',
          tag: '1 账号起售',
          recommended: false,
          features: [
            '每月每坐席基础 2000 Credit 积分', '每月每坐席赠送 2000 Credit 积分', '企业加量包购买', '第三方登录认证',
            '组织架构管理', '统一订阅管理', '成员用量控制', '企业 Skill', '企业专家', '企业智能体', '企业模型配置', '安全与审计', 'OpenAPI 开放',
          ],
          featuresNo: ['专属网络访问', '专属企业插件', '专属服务实例', '数据租户隔离']
        },
        {
          name: '企业专享版',
          desc: '面向企业和团队，提供单租户专享部署',
          price: '¥316',
          tag: '100 账号起售',
          recommended: true,
          features: [
            '每月每坐席基础 2000 Credit 积分', '每月每坐席赠送 2000 Credit 积分', '企业加量包购买', '第三方登录认证',
            '组织架构管理', '统一订阅管理', '成员用量控制', '企业 Skill', '企业专家', '企业智能体', '企业模型配置', '安全与审计', 'OpenAPI 开放',
          ],
          featuresNo: ['专属网络访问', '专属企业插件', '专属服务实例', '数据租户隔离']
        }
      ]
    }
  },
  mounted() {
    ul = document.getElementById('scrollcontainer');
    ulb = document.getElementById('scrollcontainerb');
    setmousedown(ul, isMouseDown);
    setmousedown(ulb, isMouseDownb);
  },
  methods: {
    toa(i) {
      this.$router.push({ name: 'wbIndustry', query: { index: i } })
    },
    toc() {
      if (this.$isxj)
        window.open('https://work.weixin.qq.com/kfid/kfc54a4ebac7513c548')
      else
        window.open('https://work.weixin.qq.com/kfid/kfc31843ffccca81b46')
    },
    getmodule(i) {
      const rect = document.getElementById("module" + i).getBoundingClientRect()
      // 80：向上偏移80px，根据你导航栏高度自行修改数值
      const scrollTop = rect.top + window.scrollY - 80
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      })
    },
    setRecommended(i){
      this.pricingPlans[0].recommended = false
      this.pricingPlans[1].recommended = false
      this.pricingPlans[i].recommended = true
    }
  },
  activated() {
    var id = this.$route.query.targetId
    if (id) {
      this.$nextTick(() => {
        setTimeout(function () {
          const rect = document.getElementById("module" + id).getBoundingClientRect()
          // 80：向上偏移80px，根据你导航栏高度自行修改数值
          const scrollTop = rect.top + window.scrollY - 80
          window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          })
        }, 100);
      })
    }
  }
}
function setmousedown(item, mb) {
  item.addEventListener('mousedown', (e) => {
    mb = true;
  })
  item.addEventListener('mousemove', (e) => {
    if (mb) {
      item.scrollBy(-e.movementX, 0);
    }
  })
  item.addEventListener('mouseup', (e) => {
    mb = false;
  })
  item.addEventListener('mouseleave', (e) => {
    autoScroll();
    mb = false;
  })
  // 滚动速度，数值越大滚动越快（推荐0.5 ~ 2之间）
  const speed = 0.8;
  // 滚动方向 1=向右，-1=向左
  let direction = 1;
  // 最大可滚动距离 = 内容宽度 - 容器可视宽度
  const maxScroll = item.scrollWidth - item.clientWidth;

  let animateId;
  function autoScroll() {
    // 根据方向修改滚动值
    item.scrollLeft += speed * direction;

    // 触达最右侧，切换向左回滚
    if (item.scrollLeft >= maxScroll) {
      direction = -1;
    }
    // 回到最左侧，切换向右滚动
    if (item.scrollLeft <= 0) {
      direction = 1;
    }
    animateId = requestAnimationFrame(autoScroll);
  }
  item.addEventListener('mouseenter', () => cancelAnimationFrame(animateId))
  // 启动滚动
  autoScroll();
}
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

.scene-card {
  transition: all 0.3s ease;
}

.scene-card:hover .scene-icon {
  transform: scale(1.1);
}

.scene-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.15);
}

.glass {
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.fade-in {
  animation: fadeIn 0.6s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.counter-num {
  font-variant-numeric: tabular-nums;
}

.role-row {
  position: relative;
}

.role-cell {
  position: relative;
  cursor: pointer;
}

.role-name {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}

.role-name::after {
  content: 'ⓘ';
  font-size: 12px;
  color: #9ca3af;
  opacity: 0;
  transition: opacity 0.2s, color 0.2s;
}

.role-row:hover .role-cell .role-name {
  color: #2563eb;
}

.role-row:hover .role-name::after {
  opacity: 1;
  color: #3b82f6;
}

.role-cell::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  background: linear-gradient(180deg, #3b82f6, #2563eb);
  border-radius: 0 3px 3px 0;
  opacity: 0;
  transform: scaleY(0.4);
  transition: all 0.25s;
}

.role-row:hover .role-cell::before {
  opacity: 1;
  transform: scaleY(1);
}

.role-popup {
  position: absolute;
  top: 50%;
  left: calc(100% + 8px);
  transform: translateY(-50%) translateX(-6px);
  width: 880px;
  max-width: calc(100vw - 360px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px -10px rgba(15, 40, 100, 0.20), 0 8px 20px -4px rgba(15, 40, 100, 0.10);
  padding: 22px 24px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.22s ease, transform 0.22s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.22s;
  z-index: 100;
  pointer-events: none;
  border: 1px solid #e0e7ff;
}

.role-row:hover .role-popup {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) translateX(0);
  pointer-events: auto;
}

.role-popup::before {
  content: '';
  position: absolute;
  left: -7px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid #e0e7ff;
  border-bottom: 1px solid #e0e7ff;
}

.role-popup-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px dashed #e5e7eb;
  gap: 12px;
}

.role-popup-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e3a8a;
  display: flex;
  align-items: center;
  gap: 10px;
}

.role-popup-tag {
  font-size: 11px;
  font-weight: 600;
  color: #2563eb;
  background: linear-gradient(135deg, #dbeafe, #e0e7ff);
  padding: 3px 10px;
  border-radius: 50px;
}

.role-popup-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
  line-height: 1.5;
}

.role-popup-arrow {
  font-size: 18px;
  color: #cbd5e1;
  line-height: 1;
  padding-top: 2px;
}

.role-scenarios {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.role-scenario {
  padding: 14px;
  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #e0e7ff;
  position: relative;
  transition: all 0.2s;
}

.role-scenario:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.12);
  border-color: #93c5fd;
  background: linear-gradient(135deg, #eff6ff 0%, #ffffff 100%);
}

.scenario-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 800;
  margin-bottom: 8px;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.30);
}

.scenario-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #1e3a8a;
  margin-bottom: 5px;
  line-height: 1.35;
}

.scenario-desc {
  font-size: 12px;
  color: #4b5563;
  line-height: 1.55;
  margin-bottom: 10px;
  min-height: 55px;
}

.scenario-value {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #15803d;
  background: linear-gradient(135deg, #dcfce7, #bbf7d0);
  padding: 4px 10px;
  border-radius: 50px;
}

.scrollcontainer {
  position: relative;
  overflow-x: auto;
  padding: 5px 50px;
}

.scrollcontainer::-webkit-scrollbar {
  display: none
}

@media (max-width: 768px) {
  .role-popup {
    position: static;
    transform: none;
    width: 100%;
    max-width: 100%;
    margin-top: 8px;
    box-shadow: 0 10px 24px rgba(15, 40, 100, 0.10);
    left: 0;
  }

  .role-popup::before {
    display: none;
  }

  .role-row:hover .role-popup {
    transform: none;
  }

  .role-scenarios {
    grid-template-columns: 1fr;
  }
}
</style>
